var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Background',[_c('div',{staticClass:"form-wrapper"},[(_vm.isNewPassword)?_c('NewPassword'):_c('ResetPassword')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }